import React from 'react';
import { useSelector } from 'react-redux';

import SearchResults from '../../app/Search/components/searchResults/SearchResults';
import {
  selectSearchLogParameters,
  selectShouldShowAddToFavorites,
} from '../../app/Search/selectors/searchSelectors';
import { StockItemContext } from '../../common/types/StockItemTypes';
import {
  selectDetailsIsEnterpriseMember,
  selectRedirectToSignUpLink,
  selectUseSubscriptionlessSignUpEnticement,
} from '../selectors/detailsSelectors';

interface Props {
  stockItemCardResponsiveClassNames: string[];
  similarStockItems;
}

const ArbitrarySearchResults = ({
  stockItemCardResponsiveClassNames,
  similarStockItems,
}: Props) => {
  const redirectToSignUpLink = useSelector(selectRedirectToSignUpLink);
  const searchLogParameters = useSelector(selectSearchLogParameters);
  const shouldShowAddToFavorites = useSelector(selectShouldShowAddToFavorites);
  const isEnterpriseMember = useSelector(selectDetailsIsEnterpriseMember);
  const useSubscriptionlessSignUpEnticement = useSelector(
    selectUseSubscriptionlessSignUpEnticement
  );

  return (
    <SearchResults
      currentStockItems={similarStockItems}
      searchLogParameters={searchLogParameters}
      isLoading={false}
      isLoadingAdditionalResults={false}
      selectedStockItemDetails={null}
      selectedStockItemIndex={null}
      redirectToSignUpLink={redirectToSignUpLink}
      isEnterpriseMember={isEnterpriseMember}
      shouldShowAddToFavorites={shouldShowAddToFavorites}
      context={StockItemContext.SIMILAR_CONTENT}
      stockItemContainerResponsiveClassNames={stockItemCardResponsiveClassNames}
      useSubscriptionlessSignUpEnticement={useSubscriptionlessSignUpEnticement}
    />
  );
};

export default ArbitrarySearchResults;
